import { render, staticRenderFns } from "./Form2CaseInformation.vue?vue&type=template&id=3149ee6b&scoped=true"
import script from "./Form2CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form2CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3149ee6b",
  null
  
)

export default component.exports